export enum CandidateJob {
	Teacher = 'teacher',
	Assistant = 'assistant',
	Pending = 'pending',
	Approved = 'approved',
	Denied = 'denied',
}